const soaValidator = (value) => {
  if (!value) return "validate.soa_empty";
  const regex =
    /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}\s+(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}\s+\d+\s+\d+\s+\d+\s+\d+\s+\d+$/;
  return regex.test(value) ? true : "validate.soa_failed";
};

export { soaValidator };
